<template>
    <div :style="style" class="scroll-top-button" v-show="scrollTopVisible" @click="scrollToTop">
        <font-awesome-icon :icon="['fa', 'circle-arrow-up']" size="2xl" />
    </div>
</template>

<script setup>
import { ref, onMounted, onBeforeMount } from 'vue'

const props = defineProps({
    threshold: {
        type: Number,
        default: 70
    },
    positionX: {
        type: Number,
        default: 20
    },
    positionY: {
        type: Number,
        default: 20
    }
})

const threshold = ref()
const scrollTopVisible = ref(false)
const style = ref()

onMounted(() => {
    threshold.value = props.threshold
    style.value = `right: ${props.positionX}px; bottom: ${props.positionY}px`
    window.addEventListener("scroll", onScrollHandler)
})

onBeforeMount(() => {
    window.removeEventListener("scroll", onScrollHandler)
})

const onScrollHandler = () => {
    if (window.scrollY > threshold.value) {
        scrollTopVisible.value = true
    } else {
        scrollTopVisible.value = false
    }
}

const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" })
}

</script>

<style scoped>
.scroll-top-button {
color: var(--blue-500);
    cursor: pointer;
    position: fixed;
    z-index: 100;
}
</style>